import PageMetaData from "../../components/PageMetaData";
import TopNavBar from "../../components/TopNavBar";
import Hero from "./components/Hero";
import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../context/useLayoutContext";
import Footer from "./components/Footer";
import Calculator from "./components/Calculator";
import { useState } from "react";

const Landing = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    //console.log("Calculator button clicked");
    setShowCalculator(!showCalculator);
  };

  return (
    <>
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData title="Geo Express" />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/", true],
              ["სერვისები", "services", "/services"],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />

          <Hero />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <Footer />

          {/* <Services /> */}

          {/* <FAQs /> */}

          {/* <About /> */}

          {/* <Works />
          <Stories /> */}

          {/* <ContactUs /> */}
        </LayoutProvider>
      </HelmetProvider>
    </>
  );
};

export default Landing;
